if (!window.SAS?._buttonInquireLoaded) {
  window.SAS = window.SAS || {};
  window.SAS._buttonInquireLoaded = true;

  const log = (...args) => window.SAS_DEBUG && console.log("[SAS]", ...args);

  window.SAS.showMessage = function (idSelector) {
    const messageElement = document.getElementById(idSelector);
    if (!messageElement) return;
    if (!sessionStorage.getItem(idSelector)) {
      messageElement.style.display = 'block';
      sessionStorage.setItem(idSelector, true);
      setTimeout(() => {
        messageElement.style.display = 'none';
        sessionStorage.removeItem(idSelector);
      }, 5000);
    }
  };

  document.addEventListener('DOMContentLoaded', () => {
    const modalAppointment = document.querySelector('.modal--inquired-purchase');
    const btnClose = document.querySelectorAll('.close');
    const btnInquire = document.querySelector('.btn-inquired');
    const messageSuccess = document.querySelector('.message_success.custom-appointment');
    const inputSku = document.querySelector('#ContactForm-sku');

    function getVariants() {
      const el = document.querySelector('#productVariants');
      if (!el) return [];
      try {
        return JSON.parse(el.textContent) || [];
      } catch (e) {
        log('Error parsing #productVariants:', e);
        return [];
      }
    }

    function getSkuById(variantId) {
      const variants = getVariants();
      const variant = variants.find(v => v.id === variantId);
      return variant ? variant.sku : null;
    }

    function getCurrentVariantId() {
      const input = document.querySelector('input[name="id"]');
      return input ? parseInt(input.value) : null;
    }

    function updateSkuField(variantId) {
      if (!inputSku) return;
      const id = variantId || getCurrentVariantId();
      const sku = id ? getSkuById(id) : null;
      inputSku.value = sku || '';
      if (!sku) log('SKU not found for variant:', id);
    }

    updateSkuField();

    document.addEventListener('on:variant:change', (e) => {
      updateSkuField(e.detail?.variant?.id);
    });

    if (btnInquire && modalAppointment) {
      btnInquire.addEventListener('click', (event) => {
        event.preventDefault();
        modalAppointment.style.display = 'block';
        modalAppointment.classList.add('is-active');
        setTimeout(() => updateSkuField(), 300);
      });
    }

    btnClose.forEach((item) => {
      item.addEventListener('click', (event) => {
        event.preventDefault();
        if (modalAppointment) {
          modalAppointment.style.display = 'none';
          modalAppointment.classList.remove('is-active');
        }
      });
    });

    window.addEventListener('click', (event) => {
      if (event.target === modalAppointment) {
        modalAppointment.style.display = 'none';
        modalAppointment.classList.remove('is-active');
      }
    });

    const phoneInput = document.getElementById('ContactForm-phone');
    if (phoneInput) {
      phoneInput.addEventListener('input', () => {
        phoneInput.value = phoneInput.value.replace(/\D/g, '');
      });
    }

    if (window.location.search.includes('contact_posted=true') && messageSuccess) {
      messageSuccess.style.display = 'block';
      window.addEventListener('click', () => {
        window.location = location.pathname;
      });
    }
  });
}
